<template>
    <div class="no-results-container">
        <div class="no-results-container-inner">
            <typo name="title-24-medium" class="title">
                Aucune convention collective ne correspond au(x) critère(s) :
            </typo>
            <ul>
                <li v-if="panoramaQuery.shortTitle">Titre : {{ panoramaQuery.shortTitle }}</li>
                <li v-if="panoramaQuery.apenafCode">Code NAF : {{ panoramaQuery.apenafCode }}</li>
                <li v-if="panoramaQuery.excludedSubjects">
                    Absence de dispositions conventionnelles :
                    {{ getSubjectLabel(panoramaQuery.excludedSubjects) }}
                </li>
                <li v-if="panoramaQuery.insurerCodes">
                    Organisme assureur :
                    {{ upperFirstLetter(getInsurerLabel(panoramaQuery.insurerCodes)) }}
                </li>
                <li v-if="panoramaQuery.guarantees">
                    Garanties :
                    {{ getOptionLabel(panoramaQuery.guarantees) }}
                </li>
                <li v-if="panoramaQuery.insuranceType">
                    Type d'organisme :
                    {{ upperFirstLetter(getOptionLabel(panoramaQuery.insuranceType)) }}
                </li>
                <li v-if="!checkNullOrUndefined(panoramaQuery.des)">
                    {{
                        panoramaQuery.des === "true"
                            ? this.dico.des.withDes
                            : this.dico.des.withoutDes
                    }}
                </li>
                <li v-if="panoramaQuery.csps && panoramaQuery.csps.length > 0">
                    Catégorie socioprofessionnelle : {{ getCspLabels(panoramaQuery.csps) }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Typo from "src/components/common/typo/Typo.vue";
import { get, find, upperFirst, isNil } from "lodash";

export default {
    components: {
        Typo,
    },
    props: ["panoramaQuery", "annotationOptions", "subjects", "insurers"],
    methods: {
        getOptionLabel(code) {
            return get(this.annotationOptions, `${code}.label`, "");
        },
        getInsurerLabel(code) {
            return get(this.insurers, `${code}.label`, "");
        },
        getSubjectLabel(code) {
            const subject = find(this.subjects, subject => subject.code === code);
            return subject ? subject.label : "";
        },
        upperFirstLetter(label) {
            return upperFirst(label.toLowerCase());
        },
        checkNullOrUndefined(value) {
            return isNil(value);
        },
        getCspLabels(csps) {
            return csps
                .map(csp => {
                    const cspItem = find(this.dico.cspFilterItems, item => item.code === csp);
                    return cspItem.label;
                })
                .join(", ");
        },
    },
    computed: {
        dico() {
            return this.$privateDico.convention;
        },
    },
};
</script>

<style scoped lang="sass">
.no-results-container
    display: flex
    flex-direction: column
    align-items: center
    .no-results-container-inner
        ul
            padding-left: 48px
</style>
